export default __webpack_public_path__ + "static/media/8.c8abfd67.jpeg";